export default __webpack_public_path__ + "static/six7-house-home-bg-6276bd20121a945cabe22f3208a36422.mp4";